// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3e23ff78]:export{primaryColor:#00a0df;secondaryColor:#003479;accentColor:#d91046;brandGreyColor:#4e5054;mainBackgroundColor:#f8f7f7;headerBackgroundColor:#f8f7f7}#countdown-seconds[data-v-3e23ff78]{display:inline-block;width:1.35em;text-align:right}", ""]);
// Exports
module.exports = exports;
